import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { getRequestResult } from 'redux/reducers/request'
import {
  Button,
  OnboardTitle,
  AnimatedCheck,
  Icons,
} from 'components/Antifraude'
import { CircularProgress } from '@mui/material'
import validateStageOnboarding from 'utils/validateStage'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { roles } from 'utils/constants/roles'
import { Link } from 'react-router-dom'

import Container from './styles'

export default (props) => {
  const { history } = props
  const { token } = useSelector((state) => state.token)
  const { result, loading } = useSelector((state) => state.request)
  const [loadingStage, setLoadingStage] = useState(false)
  const dispatch = useDispatch()

  const handleLoading = (newState) => {
    setLoadingStage(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.FINISH, handleLoading)
  }, [])

  useEffect(() => {
    if (!result) {
      dispatch(getRequestResult({ token }))
    }
  }, [result])

  function handleRetry() {
    history.replace({
      pathname: '/ocr',
    })
  }

  const finished = result && result.status && result.status.finished
  const approved = result && result.status && result.status.approved
  const expired = result && result.status && result.status.expired

  return (
    <Container
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      {(!result || loading || loadingStage) && (
        <div className="loading">
          <CircularProgress />
        </div>
      )}

      {result && !finished && (
        <React.Fragment>
          <OnboardTitle>Processo não finalizado!</OnboardTitle>

          <div className="icon not-finished">
            <Icons icon="errorHollow" />
          </div>

          <Button onClick={handleRetry}>Continuar Processo</Button>
        </React.Fragment>
      )}

      {result && finished && !approved && (
        <React.Fragment>
          <OnboardTitle>Processo Finalizado</OnboardTitle>

          <div className="icon error">
            <Icons icon="errorHollow" />
          </div>

          {expired && (
            <React.Fragment>
              <p className="text">
                Seu link para a validação de identidade expirou.
              </p>
              <p className="text">
                Para gerar novo link,{' '}
                <Link to={ROUTE_CONSTANTS.START}>clique aqui</Link>.<br />
              </p>
            </React.Fragment>
          )}

          {!expired && (
            <React.Fragment>
              <p className="text">
                Para prosseguir com sua solicitação, por favor entre em contato
                com a central de atendimento.
              </p>

              <a className="text" href="mailto:expansao@xpi.com.br">expansao@xpi.com.br</a>
            </React.Fragment>
          )}
        </React.Fragment>
      )}

      {result && finished && approved && (
        <React.Fragment>
          <OnboardTitle>PROCESSO FINALIZADO</OnboardTitle>
          <br />

          <div className="icon">
            <AnimatedCheck />
          </div>
          <br />
          <br />
          <p className="text">
            O processo de validação de identidade foi concluído com sucesso.
          </p>
          <p className="text">
            Você receberá um email com instruções para a finalização da criação
            de conta.
          </p>
        </React.Fragment>
      )}
    </Container>
  )
}
